import { render, staticRenderFns } from "./DeliverableAssetsListManagement.vue?vue&type=template&id=61913ad1&scoped=true"
import script from "./DeliverableAssetsListManagement.vue?vue&type=script&lang=js"
export * from "./DeliverableAssetsListManagement.vue?vue&type=script&lang=js"
import style0 from "./DeliverableAssetsListManagement.vue?vue&type=style&index=0&id=61913ad1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61913ad1",
  null
  
)

export default component.exports